import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';

@Component({
  selector: 'lib-icon-injector',
  templateUrl: './icon-injector.component.html',
  styleUrls: ['./icon-injector.component.scss'],
  imports: [CommonModule, SafeUrlPipe],
})
export class IconInjectorComponent {
  @Input() iconClass = 'injected-icon';
  @Input() pathToIcon: string;

  constructor() {
    // This is intentional
  }
}
